import { FC } from 'react';

import { Link } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { BadgeBlockInfoProps } from './model';

export const BadgeBlockAdditionalInfo: FC<BadgeBlockInfoProps> = ({ variation }) => {
    const { t } = useTranslations();

    if (variation?.alias === 'RING_SIZE') {
        return (
            <Link variant="standalone" href={t['eshop.product_page.ring_size.size_guide_link']} target="_blank">
                {t['eshop.product_page.ring_size.size_guide']}
            </Link>
        );
    }

    return null;
};
